import React from 'react'

function HomePage() {
    return (
        <div>
            This is home page
        </div>
    )
}

export default HomePage
